import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"


const SelectGrade = ({school, grade, setGrade}) => {

   let grade3
   if (school === "es") {
      grade3 = "６年生"
   } else {
      grade3 = "３年生"
   }
   
   let grade2
   if (school === "es") {
      grade2 = "５年生"
   } else {
      grade2 = "２年生"
   }

   const selectGrade3 = () => {
      if (school === "es") {
         setGrade(6)
      } else {
         setGrade(3)
      }
   }

   const selectGrade2 = () => {
      if (school === "es") {
         setGrade(5)
      } else {
         setGrade(2)
      }
   }

   const selectGrade1 = () => {
      if (school === "es") {
         setGrade(4)
      } else {
         setGrade(1)
      }
   }

   const selectGradeSub = () => {
      setGrade(3)
   }

   return (
      <SGStyles school={school} grade={grade} >
         <p className="select">学年を選択 ▼</p>
         <div className="btns">
            <button onClick={selectGrade3} className="three">{grade3}</button>
            <button onClick={selectGrade2} className="two">{grade2}</button>
            <button onClick={selectGrade1} className="one">{school === "es" ? "４年生" : "１年生"}</button>
            <button onClick={selectGradeSub} className="hide">３～１年生</button>
         </div>
      </SGStyles>
   )
}

const SGStyles = styled.div`
   .select {
      margin-top: 30px;
      text-align: center;
      font-size: 2.6rem;
      color: #FF3D01;
      display: ${({school}) => school === "other" ? "none" : "block"};
      ${media.lessThan("960px")`
         font-size: 2rem;
      `}
      ${media.lessThan("600px")`
         font-size: 1.6rem;
      `}
   }
   .btns {
      width: 80%;
      margin: 30px auto 0;
      display: ${({school}) => school === "other" ? "none" : "flex"};
      justify-content: space-between;
      ${media.lessThan("960px")`
         flex-direction: column;
         width: 70%;
      `}
      ${media.lessThan("600px")`
         width: 80%;
      `}
      button {
         display: block;
         width: ${({school}) => school === "es" ? "20%" : "27%"};
         color: #FF3D01;
         height: 50px;
         padding: 0;
         border: 3px solid #FF3D01;
         border-radius: 25px;
         background-color: #fff;
         font-size: 2.2rem;
         box-shadow: 0 3px 6px #00000029;
         transition: 0.2s;
         ${media.lessThan("960px")`
            width: 100%;
            margin-top: 10px;
         `}
         &:hover {
            cursor: pointer;
            background-color: #FF3D01;
            color: #fff;
         }
      }
      .three {
         background-color: ${({school, grade}) => {
            if (school === "hs" && grade === 3) {
               return "#FF3D01"
            } else if (school === "jhs" && grade === 3) {
               return "#FF3D01"
            } else if (school === "es" && grade ===6) {
               return "#FF3D01"
            } else {
               return "#fff"
            }
         }};
         color : ${({school, grade}) => {
            if (school === "hs" && grade === 3) {
               return "#fff"
            } else if (school === "jhs" && grade === 3) {
               return "#fff"
            } else if (school === "es" && grade ===6) {
               return "#fff"
            } else {
               return "#FF3D01"
            }
         }};
      }
      .two {
         background-color: ${({grade}) => {
            if (grade === 5 || grade === 2) {
               return "#FF3D01"
            } else {
               return "#fff"
            }
         }};
         color :${({grade}) => {
            if (grade === 5 || grade === 2) {
               return "#fff"
            } else {
               return "#FF3D01"
            }
         }};
      }
      .one {
         background-color: ${({grade}) => {
            if (grade === 4 || grade === 1) {
               return "#FF3D01"
            } else {
               return "#fff"
            }
         }};
         color :${({grade}) => {
            if (grade === 4 || grade === 1) {
               return "#fff"
            } else {
               return "#FF3D01"
            }
         }};
      }
      .hide {
         display: ${({school}) => school === "es" ? "block" : "none"};
         background-color: ${({school, grade}) => {
            if (school === "es" && grade === 3) {
               return "#FF3D01"
            } else {
               return "#fff"
            }
         }};
         color :${({school, grade}) => {
            if (school === "es" && grade === 3) {
               return "#fff"
            } else {
               return "#FF3D01"
            }
         }};
      }
   }


`

export default SelectGrade